/**
 * Dependencies.
 */
import de from './de.translate';
import el from './el.translate';
import en from './en.translate';
import es from './es.translate';
import fi from './fi.translate';
import fr from './fr.translate';
import it from './it.translate';
import pl from './pl.translate';
import pt from './pt.translate';

/**
 * Export.
 */
export default {
  'de-DE': { CAMPAIGNS: de },
  'el-GR': { CAMPAIGNS: el },
  'en-US': { CAMPAIGNS: en },
  'es-ES': { CAMPAIGNS: es },
  'fi-FI': { CAMPAIGNS: fi },
  'fr-FR': { CAMPAIGNS: fr },
  'it-IT': { CAMPAIGNS: it },
  'pl-PL': { CAMPAIGNS: pl },
  'pt-PT': { CAMPAIGNS: pt }
};
